module.exports = __webpack_public_path__ + "static/media/carMobile2.6e47754a.webp";